import React from "react";
import "./src/sass/global.scss"
import Layout from "./src/components/layouts";

export const onClientEntry = () => {
  // Google Analytics tracking
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'page_view', {
      page_path: window.location.pathname,
    });
  }
};

export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>;
};